import React from 'react';
import { Users, Code, Server, Building2, BookOpen } from "lucide-react";
import Navbar from "../../components/visitantes/Navbar"; 
import '../../scss/visitante/creditos.scss';
import heroImage from "../../assets/entradamuseu2.jpg";

/* =========================
   DADOS DOS CRÉDITOS
========================= */
const creditsData = {
  developmentTeam: [
    {
      name: "Prof. Dr. Joaquim Cezar Felipe",
      role: "FFCLRP/USP",
      description: "Idealização e coordenação geral",
      initials: "JF"
    },
    {
      name: "Milena Rodrigues Monteiro",
      role: "Discente do curso de Ciência da Computação - FFCLRP/USP",
      description: "Codificação, base de dados, layout do site, manutenção",
      initials: "MM"
    },
    {
      name: "Victor Kikuti Maceron",
      role: "Discente do curso de Ciência da Computação - FFCLRP/USP",
      description: "Codificação, base de dados, manutenção",
      initials: "VM"
    },
    {
      name: "Taysa Guiral Silva",
      role: "Discente do curso de Ciência da Computação - FFCLRP/USP",
      description: "Codificação, base de dados, layout do site, manutenção",
      initials: "TG"
    },
    {
      name: "João Victor Lopes Pereira dos Santos",
      role: "Discente do curso de Ciência da Computação - FFCLRP/USP",
      description: "Base de dados",
      initials: "JS"
    }
  ],

  collaborators: {
    sti: [
      {
        name: "Seção Técnica de Informática",
        role: "FMRP/USP",
        description: "Disponibilização do servidor e manutenção do sistema",
        initials: "STI"
      }
    ],

    memoryCenter: [
      {
        name: "Profa. Anette Hoffmann",
        role: "FMRP/USP",
        description: "Idealização e supervisão de conteúdo",
        initials: "AH"
      },
      {
        name: "Silvana Aparecida Moreira Delfino",
        role: "",
        description: "Organização e revisão de conteúdo",
        initials: "SD"
      }
    ],

    libraryScience: [
      {
        name: "Profa. Dra. Silvia Maria do Espírito Santo",
        role: "Biblioteconomia e Ciência da Informação - FFCLRP/USP",
        description: "Supervisão da revisão do acervo",
        initials: "SS"
      },
      {
        name: "Estagiários do curso de Biblioteconomia e Ciência da Informação",
        role: "FFCLRP/USP",
        description: "Revisão do acervo",
        initials: "BCI"
      }
    ]
  },

  version: "2.0.0",
  lastUpdate: "Dezembro 2025"
};

/* =========================
   COMPONENTES
========================= */
const PersonCard = ({ name, role, description, initials, variant = "primary" }) => (
  <div className={`person-card variant-${variant}`}>
    <div className="card-header">
      <div className={`avatar ${variant}`}>
        {initials}
      </div>
      <div className="header-info">
        <h3 className="name">{name}</h3>
        {role && <span className="role">{role}</span>}
      </div>
    </div>
    <div className="card-content">
      <p className="description">{description}</p>
    </div>
  </div>
);

const SectionHeader = ({ icon, title }) => (
  <div className="section-header">
    <div className="icon-wrapper">{icon}</div>
    <h2>{title}</h2>
  </div>
);

/* =========================
   PÁGINA DE CRÉDITOS
========================= */
const Credits = () => {
  return (
    <div className="credits-page">
      <Navbar />

      {/* HERO */}
      <section className="hero-section">
        <div
          className="hero-background"
          style={{ backgroundImage: `url(${heroImage})` }}
        >
          <div className="hero-overlay"></div>
        </div>

        <div className="container hero-content">
          <h1>Créditos do Sistema Computacional</h1>
        </div>
      </section>

      {/* CONTEÚDO */}
      <main className="container main-content">

        {/* EQUIPE DE DESENVOLVIMENTO */}
        <section className="credit-section">
          <SectionHeader
            icon={<Code size={24} />}
            title="Equipe de Desenvolvimento"
          />

          <div className="cards-grid">
            {creditsData.developmentTeam.map((person, index) => (
              <PersonCard
                key={index}
                {...person}
                variant="primary"
              />
            ))}
          </div>
        </section>

        {/* COLABORADORES */}
        <section className="credit-section">
          <SectionHeader
            icon={<Users size={24} />}
            title="Colaboradores"
          />

          {/* STI */}
          <h3 className="subsection-title">
            <Server size={18} /> Seção Técnica de Informática
          </h3>
          <div className="cards-grid">
            {creditsData.collaborators.sti.map((person, index) => (
              <PersonCard
                key={index}
                {...person}
                variant="secondary"
              />
            ))}
          </div>

          {/* Centro de Memória */}
          <h3 className="subsection-title">
            <Building2 size={18} /> Centro de Memória
          </h3>
          <div className="cards-grid">
            {creditsData.collaborators.memoryCenter.map((person, index) => (
              <PersonCard
                key={index}
                {...person}
                variant="secondary"
              />
            ))}
          </div>

          {/* Biblioteconomia */}
          <h3 className="subsection-title">
            <BookOpen size={18} /> Biblioteconomia e Ciência da Informação
          </h3>
          <div className="cards-grid">
            {creditsData.collaborators.libraryScience.map((person, index) => (
              <PersonCard
                key={index}
                {...person}
                variant="secondary"
              />
            ))}
          </div>
        </section>

      </main>
    </div>
  );
};

export default Credits;
